import type { ReactNode } from 'react'

/**
 * One labelled group in the dev rail.
 *
 * The rail is grouped rather than flat because its membership changes per mode: a flat list of
 * eleven buttons where four silently vanish in `replica` is unreadable, and the reader's first
 * question — "is this thing missing because of the mode, or because I'm looking in the wrong
 * place" — is exactly what a heading answers.
 *
 * Each caller decides whether it has anything to show and returns null if not; an empty section
 * heading is worse than no section.
 */
export default function DevSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="gameweek-grid__dev-section">
      <p className="gameweek-grid__dev-section-title label-section">{title}</p>
      <div className="gameweek-grid__dev-buttons">{children}</div>
    </section>
  )
}
